export enum FORM_ACTIONS {
	CREATE = "CREATE",
	UPDATE = "UPDATE",
}
